/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, memo, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { toAbsoluteUrl } from '@/_metronic/helpers'
import { BaseRequest } from '@/_metronic/helpers/crud-helper/base-request'
import { RESP } from '@/_metronic/helpers/network/network-consts'
import { DropdownSelect } from '@/_metronic/partials/content/dropdown-select/DropdownSelect'
import { FilterMasterData, MasterData } from '@/app/core/master-data/_models'
import { getMasterDataDropdown } from '@/app/core/master-data/_requests'
import { useAuth } from '@/app/modules/auth'
import { QueryRequestProvider as RatingQueryRequestProvider } from '@/app/modules/rating-by-therapist/core/QueryRequestProvider'
import {
  QueryRequestProvider,
  useQueryRequest,
} from '@/app/modules/report-trend-analysis/core/QueryRequestProvider'
import {
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
} from '@/app/modules/report-trend-analysis/core/QueryResponseProvider'
import moment from 'moment'
import { Button, Modal } from 'react-bootstrap'
import { PageTitle } from '../../../../_metronic/layout/core'
import ReportMainDashboard from './components/ReportMainDashboard'
import { RevenueBar } from './components/RevenueBar'
import { TopArea } from './components/TopArea'
import { TopCity } from './components/TopCity'
import { TopOutlet } from './components/TopOutlet'
import { TreatmentBar } from './components/TreatmentBar'
import { TopQueryRequestProvider, useTopQueryRequest } from './core/QueryRequestTopProvider'
import { AreaQueryResponseProvider, useAreaQueryResponseData } from './core/QueryResponseAreaProvider'
import { CityQueryResponseProvider, useCityQueryResponseData } from './core/QueryResponseCityProvider'
import { OutletQueryResponseProvider } from './core/QueryResponseOutletProvider'

const FRONT_OFFICE = '72b0ad30-d847-47bc-af21-80f0eddca117'
const RECEIPTIONIST = '888b34c8-32f9-4554-ac98-d9696350e457'
const CASHIER = '5e10a0fb-22f7-4523-b2e1-5a9532fd741b'
const OWNER = 'd5261a49-ba33-4c44-b7c2-e7da57191ea5'

const MemoizeRevenueBar = memo(RevenueBar)
const MemoizeTreatmentBar = memo(TreatmentBar)

function generateYears() {
  const startYear: number = 2023
  const currentYear = moment().year() // Get the current year using moment.js
  const years: number[] = []

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year)
  }

  return years
}

const DashboardPage: FC = () => {
  const [showModalSubBrand, setShowModalSubBrand] = useState<boolean>(false)
  const [subBrands, setSubBrands] = useState<MasterData[]>([])

  const {state, updateState} = useQueryRequest()
  const {state: stateTopOutlet, updateState: updateStateTopOutlet} = useTopQueryRequest()
  const {state: stateTopCity, updateState: updateStateTopCity} = useTopQueryRequest()
  const {state: stateTopArea, updateState: updateStateTopArea} = useTopQueryRequest()
  const {currentUser} = useAuth()
  const data = useQueryResponseData()
  const response = useQueryResponse()
  const isLoading = useQueryResponseLoading()
  const dataCity = useCityQueryResponseData()
  const dataArea = useAreaQueryResponseData()
  const currentDate = new Date()
  const arrayMonth = [
    (currentDate.getMonth() - 4).toString(),
    (currentDate.getMonth() - 3).toString(),
    (currentDate.getMonth() - 2).toString(),
    (currentDate.getMonth() - 1).toString(),
    currentDate.getMonth().toString(),
    (currentDate.getMonth() + 1).toString(),
  ]

  console.log({currentUser})

  useEffect(() => {
    updateState({
      month: [],
    })
  }, [])

  useEffect(() => {
    if (currentUser?.detail_data?.job?.job_id === OWNER) {
      const fetchMasterDataDropdown = async () => {
        try {
          const body = {
            filter: {
              set_parent_id: false,
              parent_id: '',
              set_category: true,
              category: 'Sub Brand',
              set_value: false,
              value: '',
            },
            limit: 100,
            page: 1,
            order: 'name',
            sort: 'ASC',
          } as BaseRequest<FilterMasterData>

          const res = await getMasterDataDropdown(body)

          if (res?.response?.code === RESP.SUCCESS) {
            setSubBrands(res?.response?.data || [])
          }
        } catch (error) {
          console.log({error})
        }
      }
      setShowModalSubBrand(true)
      fetchMasterDataDropdown()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  const handleSubBrandClick = (subBrandId?: string, subBrandName?: string) => {
    console.log({subBrandId})
    setShowModalSubBrand(false)
    updateState({
      set_sub_brand_id: Boolean(subBrandId),
      sub_brand_id: subBrandId ? [subBrandId] : [],
      sub_brand_name: subBrandName ? [subBrandName] : [],
    })
    updateStateTopOutlet({
      set_sub_brand_id: Boolean(subBrandId),
      sub_brand_id: subBrandId ? [subBrandId] : [],
    })
    updateStateTopCity({
      set_sub_brand_id: Boolean(subBrandId),
      sub_brand_id: subBrandId ? [subBrandId] : [],
    })
    updateStateTopArea({
      set_sub_brand_id: Boolean(subBrandId),
      sub_brand_id: subBrandId ? [subBrandId] : [],
    })
  }

  const isOwner = useMemo(() => {
    return currentUser?.detail_data?.job?.job_id === OWNER
  }, [currentUser])

  console.log({state})

  return (
    <>
      <Modal
        show={showModalSubBrand}
        onHide={() => setShowModalSubBrand(false)}
        className='select-dashboard'
        size='lg'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5>Select Your Dashboard</h5>
          </div>
          <div className='modal-body'>
            <div className='row g-3 g-md-4'>
              <div className='col-4 col-sm-4 col-lg-3 col-xl-3'>
                <Button
                  variant='outline-dark'
                  className='w-100 h-100 d-flex flex-column align-items-center justify-content-center'
                  style={{minHeight: '100px', padding: '1rem'}}
                  onClick={() => handleSubBrandClick()}
                >
                  <span className='fs-5 fw-semibold'>All</span>
                </Button>
              </div>
              {subBrands.map((subbrand) => (
                <div key={subbrand.guid} className='col-4 col-sm-4 col-lg-3 col-xl-3'>
                  <Button
                    variant='outline-dark'
                    onClick={() => handleSubBrandClick(subbrand.guid || '', subbrand.value || '')}
                    className='w-100 h-100 d-flex flex-column align-items-center justify-content-center'
                    style={{minHeight: '100px', padding: '0.75rem'}}
                  >
                    <img
                      src={toAbsoluteUrl(`/media/logos/${subbrand.guid}.png?v=20261001`)}
                      alt={subbrand.value}
                      className='w-100'
                      style={{maxHeight: '30px', objectFit: 'contain'}}
                    />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
      {[FRONT_OFFICE, RECEIPTIONIST, CASHIER].includes(
        currentUser?.detail_data?.job?.job_id as string
      ) ? (
        <div className='g-5 w-100 h-100 text-center fs-1 text-primary fw-bold'>
          Welcome Back, {currentUser?.detail_data?.fullname}
        </div>
      ) : (
        <>
          <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
            {/* Filter Year and Sub Brand */}
            {isOwner && (
              <div className='col-12 d-flex align-items-center justify-content-between pt-5'>
                <div className='w-250px'>
                  <DropdownSelect
                    options={generateYears().map((x) => ({label: x, value: x}))}
                    value={state.year ? {label: state.year, value: state.year} : null}
                    onChange={(newValue) => updateState({year: newValue?.value})}
                    isClearable={false}
                  />
                </div>
                <Button type='button' onClick={() => setShowModalSubBrand(true)}>
                  Filter :{' '}
                  {(state.sub_brand_name?.length || 0) > 0 ? state.sub_brand_name : 'All Brand'}
                </Button>
              </div>
            )}

            {/* Report Main Dashboard */}
            <ReportMainDashboard />

            {/* Top Outlet, City, and Area */}
            <div className='row g-4 mt-8'>
              <div className='col-12 col-md-6 col-lg-4'>
                <TopOutlet className='h-100' />
              </div>
              <div className='col-12 col-md-6 col-lg-4'>
                <TopCity className='h-100' />
              </div>
              <div className='col-12 col-md-6 col-lg-4'>
                <TopArea className='h-100' />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <RatingQueryRequestProvider>
        <QueryRequestProvider>
          <TopQueryRequestProvider>
            <OutletQueryResponseProvider>
              <CityQueryResponseProvider>
                <AreaQueryResponseProvider>
                  <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.HOME'})}</PageTitle>
                  <DashboardPage />
                </AreaQueryResponseProvider>
              </CityQueryResponseProvider>
            </OutletQueryResponseProvider>
          </TopQueryRequestProvider>
        </QueryRequestProvider>
      </RatingQueryRequestProvider>
    </>
  )
}

export { DashboardWrapper }

